import Title from "../components/sections/Title";
import WideContainer from "../components/WideContainer";
import CenteredRow from "../components/CenteredRow";
import BundlePrice from "../components/BundlePrice";
import { billing, bundles, cashOnly, disclaimer } from "../content/Prices";

function Prices() {
  return (
    <main className="flex-grow-1">
      <Title title="Árlista" />
      <WideContainer>
        <h1 className="display-6 fw-bold text-body-emphasis quint palegreen text-center mb-4">
          Csomag ajánlatok
        </h1>
        <div className="row row-cols-1 text-center mb-4 g-5 px-0 px-md-2 px-lg-4">
          {bundles.map((bundle, i) => (
            <BundlePrice
              key={i}
              title={bundle.title}
              desc={bundle.desc}
              duration={bundle.duration}
              singlePrice={bundle.singlePrice}
              bundlePrice={bundle.bundlePrice}
              bundleDesc={bundle.bundleDesc}
              details={bundle.details}
              color={bundle.color}
            />
          ))}
        </div>
        <div className="row justify-content-center">
          <div className="col-10">
            <hr className="hr palegreen" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <p className="mb-2 text-center">{disclaimer}</p>
          </div>
        </div>
      </WideContainer>
      <WideContainer id="payment">
        <CenteredRow>
          <p className="mb-2 text-danger">
            <b>{billing}</b>
          </p>
          <p className="mb-2 text-danger">
            <b>{cashOnly}</b>
          </p>
        </CenteredRow>
      </WideContainer>
    </main>
  );
}

export default Prices;
